// eslint-disable-file
import { Row } from 'farmhub-ui-core';

import { SlideSection } from 'components/Section';
import { TEMPLATE } from 'utils';

import ObjectSelectItem from '../ObjectSelectItem';

type ObjectSelectProps = {
  objectTypeActive: string;
  amountItem?: number;
  onSelect: (val: string) => void;
};

const ObjectSelect = ({
  amountItem = 8,
  objectTypeActive,
  onSelect,
}: ObjectSelectProps) => (
  <SlideSection
    sectionProps={{
      wrapperPadding: '0',
      styles: {
        backgroundColor: '#FFFFFF',
      },
    }}
    slideShowProps={{ spacing: 0, wrapperPadding: '0px' }}
  >
    <Row width="100%">
      {TEMPLATE.map((item: any) => (
        <Row
          styles={{
            width: `calc(100% / ${amountItem})`,
            padding: '0px 6px',
            flexShrink: 0,
          }}
          onClick={() => onSelect(item.code)}
        >
          <ObjectSelectItem
            icon={item.icon}
            selected={item.code == objectTypeActive}
            title={item.label}
          />
        </Row>
      ))}
    </Row>
  </SlideSection>
);

export default ObjectSelect;
